// Pure-CSS product mockup for the SayIt Manager Edition.
// Swap `coverContent` for an <img> once the final cover artwork is supplied.
export function BookMockup({ className = "" }) {
  return (
    <div className={`relative ${className}`} style={{ transformStyle: "preserve-3d" }}>
      {/* page block */}
      <div
        aria-hidden="true"
        className="absolute inset-0 translate-x-[10px] translate-y-[6px] rounded-r-md rounded-l-[2px] border border-[#d8d5cc]"
        style={{
          background:
            "repeating-linear-gradient(to right, #ffffff 0px, #ffffff 2px, #efede6 2px, #efede6 3px)",
        }}
      />
      {/* back cover shadow edge */}
      <div
        aria-hidden="true"
        className="absolute inset-0 translate-x-[5px] translate-y-[3px] rounded-r-md rounded-l-[2px] bg-[#0e0d0b]"
      />
      {/* front cover */}
      <div className="relative aspect-[3/4.15] overflow-hidden rounded-r-md rounded-l-[3px] bg-[#161511] shadow-[0_1px_0_rgba(255,255,255,0.06)_inset]">
        {/* spine */}
        <div
          aria-hidden="true"
          className="absolute inset-y-0 left-0 w-[14px]"
          style={{
            background:
              "linear-gradient(to right, #000000 0%, #2a2823 45%, #161511 100%)",
          }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-y-0 left-[14px] w-px bg-white/10"
        />
        {/* cover art */}
        <div className="absolute inset-0 flex flex-col justify-between py-8 pl-10 pr-7 sm:py-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-[#8a8578]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8578]">
                SayIt Press
              </span>
            </div>
          </div>
          <div>
            <p className="font-display text-[2.6rem] leading-[1.02] text-[#f2eee3] sm:text-5xl">
              100 Difficult
              <span className="block italic font-light text-[#d8d2c2]">
                Messages
              </span>
            </p>
            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-[#a39d8d]">
              for Managers
            </p>
            <div className="mt-6 flex items-center gap-2 text-[#c9c3b4]">
              <span className="h-1.5 w-1.5 rounded-full bg-amber-500/80" />
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500/70" />
              <span className="h-1.5 w-1.5 rounded-full bg-rose-500/70" />
              <span className="ml-2 font-mono text-[9px] uppercase tracking-[0.2em] text-[#8a8578]">
                Warm · Balanced · Firm
              </span>
            </div>
          </div>
          <div className="flex items-end justify-between border-t border-white/10 pt-4">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8a8578]">
              Manager Edition
            </span>
            <span className="font-mono text-[10px] tracking-[0.15em] text-[#6b675c]">
              117 pp
            </span>
          </div>
        </div>
        {/* sheen */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "linear-gradient(115deg, rgba(255,255,255,0.09) 0%, rgba(255,255,255,0.02) 28%, rgba(255,255,255,0) 45%)",
          }}
        />
      </div>
    </div>
  );
}
